// extracted by mini-css-extract-plugin
export default {"heading":"DeliveryOption_heading__wRB7H","wrapper":"DeliveryOption_wrapper__4kJsk"};